import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { UsuarioService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-dialogCambioPassword',
  templateUrl: './dialogCambioPassword.component.html',
  styleUrls: ['./dialogCambioPassword.component.css']
})
export class DialogCambioPasswordComponent implements OnInit {

  formGroup: FormGroup;
  hideClaveNueva: boolean = true;
  hideClaveActual: boolean = true;
  hideConfirmClave: boolean = true;
  buttonEnabled: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<DialogCambioPasswordComponent>,
    private usuarioService: UsuarioService,
    private sharedFunctions: SharedFunctions,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
     'ClaveActual': [null, Validators.required],
     'ClaveNueva': [null, Validators.required],
     'ConfirmClave': [null, Validators.required]
    });
  }

  onGuardar() {
    if(!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Complete los campos obligatorios para continuar con la operación", "Error");
      return false;
    }

    if (this.formGroup.get('ClaveNueva')?.value?.toString() != this.formGroup.get('ConfirmClave')?.value?.toString()) {
      this.sharedFunctions.showMessage("Revise la nueva clave y su confirmación ya que son diferentes", "Error");
      return false;
    }

    var value = { ... this.formGroup.getRawValue() };
    this.buttonEnabled = false;

    this.usuarioService.changeMyPassword(value).subscribe(data => {
      this.buttonEnabled = true;
      if(data.Success) {
        let result = data.Result;


        if (result) {
          this.sharedFunctions.showMessage("Se modificó exitosamente la clave.", "Cambio de Clave");
          this.dialogRef.close(result);
        }
      }
      else
        this.sharedFunctions.showMessage("Ocurrió un error cambiando la clave del usuario", "Error");
    },
    (err: HttpErrorResponse) => {
      this.buttonEnabled = true;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancelar() {
    this.dialogRef.close(null);
  }

  getErrorClaveActual() {
    return this.formGroup.get('ClaveActual')?.hasError('required') ? 'Este campo es obligatorio' : '';
  }

  getErrorClaveNueva() {
    return this.formGroup.get('ClaveNueva')?.hasError('required') ? 'Este campo es obligatorio' : '';
  }

  getErrorConfirmClave() {
    return this.formGroup.get('ConfirmClave')?.hasError('required') ? 'Este campo es obligatorio' : '';
  }
}
